//
import Card from './Card';
import Paper from './Paper';
import Input from './Input';
import Table from './Table';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import Autocomplete from './Autocomplete';
import FormControl from './FormControl';
import FormControlLabel from './FormControlLabel';
import TextField from './TextField';
import Dialog from './Dialog';
import Container from './Container';
import Tabs from './Tabs';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Card(theme),
    Table(theme),
    Input(theme),
    Paper(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    Autocomplete(theme),
    FormControl(theme),
    FormControlLabel(theme),
    TextField(theme),
    Dialog(theme),
    Container(theme),
    Tabs(theme)
  );
}
